import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import NavBar from "../general/NavBar";
import Sidebar from "../general/Sidebar";

const ProtectedRoute = ({ authUser }) => {
  if (!authUser) return <Navigate to="/" />;

  return (
    <div className="app-shell">
      <NavBar />
      <div className="app-shell-body">
        <Sidebar />
        <main className="app-shell-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default ProtectedRoute;
